export default class PriceListItem {};